/**
 * Product extras on the single product page (markup: partials/product-aufsteller-optin,
 * partials/product-beilage; data via mu-plugin aa-wc-hcp-product):
 * - opt-in checkbox for the free Aufsteller, synced to the WooCommerce session
 * - „Patienteninformation“ count following the variation / quantity field
 * - lightbox for both images via WooCommerce's PhotoSwipe, with wheel zoom
 */

const format = (n) => n.toLocaleString('de-DE');

function openLightbox(link) {
  const container = document.querySelector('.pswp');
  if (!container || !window.PhotoSwipe || !window.PhotoSwipeUI_Default) {
    return false;
  }

  const caption = typeof link.lightboxCaption === 'function' ? link.lightboxCaption() : link.dataset.caption || '';
  const gallery = new window.PhotoSwipe(
    container,
    window.PhotoSwipeUI_Default,
    [{ src: link.href, w: Number(link.dataset.width), h: Number(link.dataset.height), title: caption }],
    {
      index: 0,
      history: false,
      shareEl: false,
      fullscreenEl: false,
      counterEl: false,
      maxSpreadZoom: 5,
      getDoubleTapZoom: (isMouseClick, item) => (isMouseClick ? 2.5 : (1 / item.fitRatio) * 0.9),
      barsSize: { top: 44, bottom: 'auto' },
    },
  );
  gallery.init();

  const onWheel = (event) => {
    event.preventDefault();
    const item = gallery.currItem;
    if (!item) return;
    const min = item.initialZoomLevel;
    const max = Math.max(min * 5, 1.2);
    const zoom = gallery.getZoomLevel() * (event.deltaY < 0 ? 1.18 : 1 / 1.18);
    gallery.zoomTo(Math.min(Math.max(zoom, min), max), { x: event.clientX, y: event.clientY }, 120);
  };
  container.addEventListener('wheel', onWheel, { passive: false });
  gallery.listen('destroy', () => container.removeEventListener('wheel', onWheel));

  return true;
}

function bindLightbox(root, caption) {
  root.querySelectorAll('[data-lightbox]').forEach((link) => {
    link.lightboxCaption = caption;
    link.addEventListener('click', (event) => {
      if (openLightbox(link)) event.preventDefault();
    });
  });
}

/* ── Aufsteller opt-in ─────────────────────────────────────────────── */

function initAufsteller(card) {
  const checkbox = card.querySelector('input[type="checkbox"]');

  checkbox?.addEventListener('change', () => {
    const body = new URLSearchParams({ optin: checkbox.checked ? '1' : '0', nonce: card.dataset.nonce });
    fetch(card.dataset.endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    });
  });

  bindLightbox(card);
}

/* ── Patienteninformation enclosure ────────────────────────────────── */

function initBeilage(root) {
  const mode = root.dataset.mode;
  const badge = root.querySelector('[data-beilage-badge]');
  let current = null;

  const setText = (element, text) => {
    if (!element || element.textContent === text) return;
    element.textContent = text;
    element.classList.remove('is-updated');
    void element.offsetWidth; // restart the pulse animation
    element.classList.add('is-updated');
  };

  const updateVariation = (count) => {
    current = count;
    setText(root.querySelector('[data-beilage-title]'), count ? `${format(count)} × Patienteninformation` : 'Patienteninformation je Ausweis');
    setText(badge, count ? `${format(count)}×` : '1× je Ausweis');
  };

  const updateQty = (value) => {
    let count = parseInt(value, 10);
    if (Number.isNaN(count) || count < 1) count = 1;
    current = count;
    setText(root.querySelector('[data-beilage-sub]'), count === 1 ? 'Liegt Ihrem Ausweis bei.' : `Liegt jedem Ausweis bei – ${format(count)} Exemplare.`);
    if (badge) {
      badge.hidden = count < 2;
      if (count >= 2) setText(badge, `${format(count)}×`);
    }
  };

  const caption = () => {
    if (mode === 'qty') {
      return current === 1 ? 'Patienteninformation – liegt Ihrem Ausweis bei' : `Patienteninformation – ${format(current)} Exemplare, eines je Ausweis`;
    }
    return current ? `Patienteninformation – ${format(current)} Exemplare liegen Ihrer Bestellung bei` : 'Patienteninformation – liegt der Bestellung in gewählter Stückzahl bei';
  };

  bindLightbox(root, caption);

  // the whole card opens the lightbox, not just the thumbnail
  root.addEventListener('click', (event) => {
    if (event.target.closest('a')) return;
    if (String(window.getSelection?.() ?? '')) return;
    const link = root.querySelector('[data-lightbox]');
    if (link && !openLightbox(link)) window.open(link.href, '_blank', 'noopener');
  });

  if (mode === 'qty') {
    const form = document.querySelector('form.cart');
    const input = form?.querySelector('input[name="quantity"]');
    if (!input) {
      updateQty(1);
      return;
    }
    const sync = () => updateQty(input.value);
    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    form.addEventListener('click', () => setTimeout(sync, 0)); // +/- buttons
    sync();
    return;
  }

  // variation mode: WooCommerce's variation form fires jQuery events
  const initVariation = () => {
    if (!window.jQuery) {
      setTimeout(initVariation, 50);
      return;
    }
    window.jQuery(($) => {
      const $form = $('form.variations_form');
      if (!$form.length) {
        updateVariation(null);
        return;
      }
      const sync = () => {
        let raw = $form.find('select[name="attribute_paketgroesse"]').val();
        if (raw == null) raw = $form.find('select[name^="attribute_"]').val();
        const count = parseInt(String(raw || '').replace(/\D/g, ''), 10);
        updateVariation(Number.isNaN(count) || !count ? null : count);
      };
      $form.on('found_variation reset_data hide_variation', sync);
      $form.on('change', 'select[name^="attribute_"]', sync);
      sync();
    });
  };
  initVariation();
}

document.querySelectorAll('[data-aufsteller-optin]').forEach(initAufsteller);
document.querySelectorAll('[data-beilage]').forEach(initBeilage);
